import {RESOURCE_TYPE_SINGULAR} from './Policy.types'
import {AnalyticsSearchQueryParams, TopActivityUser} from './ShadowIT.types'

export interface ProductivityRequest {
  params?: AnalyticsSearchQueryParams
}

export interface ProductivityResponse {
  categories: ProductivityCategory[]
  topUsers: TopActivityUser[]
  totalDataConsumed: number
  totalNoOfTransactions: number
}

export interface ProductivityCategory {
  categoryId: string | number
  categoryName: string
  dataConsumed: number
  noOfTransactions: number
  bandwidthConsumed: string
  domains: ProductivityDomain[]
  topUsers: TopActivityUser[]
}

export interface ProductivityDomain {
  domainName: string
  dataConsumed: number
  noOfTransactions: number
  bandwidthConsumed: string
  users: TopActivityUser[]
}

// donut chart selectors
export interface DonutChartCircle extends ProductivityCategory {
  y: number
  drilldown: boolean
  color: string
}
export interface DonutChartCircleForDomain extends ProductivityDomain {
  y: number
  drilldown: boolean
  color: string
}

export enum ACTIVITY_BY_TIME {
  Week = 'Week',
  Day = 'Day',
}

export interface ActivityByTimeResponse {
  activityByTime?: ActivityByTime[]
  dailyAverageData: number
  dailyAverageTransactions: number
}

export interface ActivityByTime {
  categories: ActivityByTimeCategory[]
  date: number
}
export interface ActivityByTimeCategory {
  categoryName: string
  dataConsumed: number
  noOfTransactions: number
}

export interface ActivityByTimeRequest {
  activityByTimeFormat: ACTIVITY_BY_TIME
  params?: AnalyticsSearchQueryParams
}

export interface AnalyticsActivityByTimeSliceState {
  activityByTimeFormat: ACTIVITY_BY_TIME
}

export interface AnalyticsTopCategoriesSliceState {
  title: string
}

export interface HighestDataConsumedType {
  activityByTimeHighestDataConsumed: number
  activityByTimeXAxisCategory: string[]
}

// bar chart types

export interface ActivityByTimeBarChartCartItem {
  name: string
  color: string
  data: ActivityByTimeBarChartCartDataItem[]
}
export interface ActivityByTimeBarChartCartDataItem
  extends ActivityByTimeCategory {
  name: string
  dataConsumedText: string
  y: number
}
export interface DataConsumedLabel {
  dataConsumed: number
  dataConsumedText: string
}

// search input redux state interface

export interface ProductivitySearchInputState {
  searchTerm: string
  searchDisplayValue: string
  searchType: RESOURCE_TYPE_SINGULAR
  name?: string
}

// Time Stamp
export interface TopCategoriesTimeStampState {
  timeStamp: number
}
